import { getApiBaseUrl } from '../../utils/environment.mjs';
import axios from 'axios';

const API_URL = getApiBaseUrl();

// Configure axios with credentials
const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});


// Fetch expense claims (all statuses)
export const fetchExpenseClaims = async () => {
  try {
    const response = await axiosInstance.get('/expenses/claims?view=my-claims');
    
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching expense claims:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch expense claims');
  }
};


// Get expense claim by ID
export const getExpenseClaimById = async (claimId) => {
  try {
    const response = await axiosInstance.get(`/expense/claims/${claimId}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching expense claim:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch expense claim');
  }
};


// Similar functions for per diem and travel claims
export const fetchPerDiemClaims = async () => {
  try {
    const response = await axiosInstance.get('/perdiem/claims?view=my-claims');
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching per diem claims:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch per diem claims');
  }
};


// export const getPerDiemClaimById = async (claimId) => {
//   try {
//     const response = await axiosInstance.get(`/perdiem/claims/${claimId}`);

//   } catch (error) {
//     console.error('Error fetching expense claim:', error);
//     throw new Error(error.response?.data?.message || 'Failed to fetch expense claim');
//   }
// };

// Update expense item
export const updateExpenseItem = async (itemId, itemData) => {
  try {
    const response = await axiosInstance.put(`/expense/items/${itemId}`, itemData);
    return response.data;
  } catch (error) {
    console.error('Error updating expense item:', error);
    throw new Error(error.response?.data?.message || 'Failed to update expense item');
  }
};

// Delete expense item
export const deleteExpenseItem = async (itemId) => {
  try {
    const response = await axiosInstance.delete(`/expense/items/${itemId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting expense item:', error);
    throw new Error(error.response?.data?.message || 'Failed to delete expense item');
  }
};


// Delete a single expense draft claim
export const deleteExpenseClaim = async (claimId) => {
  try {
    const response = await axiosInstance.delete(`/expenses/claim/${claimId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete expense claim');
  }
};

// Delete a single per diem draft claim
export const deletePerDiemClaim = async (claimId) => {
  try {
    const response = await axiosInstance.delete(`/perdiem/claims/${claimId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete per diem claim');
  }
};

// export const fetchTravelClaims = async () => {
//   try {
//     const response = await axiosInstance.get('/travel/claims');
//     return response.data.data || [];
//   } catch (error) {
//     console.error('Error fetching travel claims:', error);
//     throw new Error(error.response?.data?.message || 'Failed to fetch travel claims');
//   }
// };

